export const CREATE_REMINDER  = 'CREATE_REMINDER';
export const GET_REMINDER  = 'GET_REMINDER';
export const REMINDER_REQUEST  = 'REMINDER_REQUEST';
export const DELETE_REMINDER  = 'DELETE_REMINDER';
export const UPDATE_REMINDER  = 'UPDATE_REMINDER';
export const REMINDER_REQUEST_FAILURE  = 'REMINDER_REQUEST_FAILURE';